import PbAjax from 'up-pbajax';
import publicpb from '../../base/public.pb';
import detailpb from './detail.pb';
import lang from '../../lang';
import global from '../../base/global';

let pbajax = new PbAjax();

class TopicDetail {
    constructor(data) {
        this.promise = this.getData(data);
    }

    getData(data) {
        let self = this;
        let { Request, Response } = detailpb.Dynamic.TopicHots;
        let businessData = new Request(data);
        
        let defer = $.Deferred();

        pbajax.do({
                service: 'dynamic',
                api: '/dynamic/topic/hots',  
                header: {
                    usertoken: global.getUser().userToken,
                    'Accept-Language': lang.type,
                    lang: lang.type,
                    UserAgent: global.getGlobalUA()
                }
            },
            businessData,
            function(res) {
                let dataWrap = publicpb.Result.decode(res);
                let data;
                
                switch (dataWrap.code) {
                    case 1:
                        data = Response.decode(dataWrap.data.value);
                        console.log('topicdetail', data);
                        defer.resolve(data);
                        break;
                    case 73731: // 被删除或不存在
                        defer.resolve({
                            errmsg: 'noexist'
                        });  
                        break;
                    case 73732: // 没有权限 
                        defer.resolve({
                            errmsg: 'noright'
                        }); 
                        break;
                    case 73733: // 计算中
                        defer.resolve({
                            errmsg: 'incalculation'
                        }); 
                        break;
                    case 8192:
                        // 授权
                        $.channel.emit('login');
                        break;
                    default:

                    defer.reject();
                }
            },
            () => {
                defer.reject();
            },
            () => {
                defer.reject();
            }
        );

        return defer.promise();
    }
}

export default TopicDetail;


// WEBPACK FOOTER //
// ./js/component/topic/index.js